"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptType = exports.CustomerRequestHandler = void 0;
const BaseRequestHandler_1 = require("../../requestHandler/BaseRequestHandler");
const getRequestConfigWithToken_1 = require("../../requestHandler/getRequestConfigWithToken");
const timer_1 = __importDefault(require("../../logger/timer"));
const baseURL = window.location.origin;
class CustomerRequestHandler {
    /**
     * Creates or updates a customer via `POST` based on the two  mandatory fields `email`,
     * `newsletterFlag`, and other optional parameters. optIn mail process will be started if
     * mandatory `newsletterFlag` param is toggled to true. Note: if customerId is given,
     * you can also update various properties with a `.updateProperties(..)` method call
     * @param shopId Sales channel id
     * @param params Various params including mandatory fields: `email` and `newsletterFlag`
     * @returns Always returns `success: true` or throws an error
     */
    static createOrUpdateCustomer(shopId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = params;
            yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("POST", `/shop/${shopId}/customers`, undefined, configuration);
        });
    }
    /**
     * Retrieves customer's properties by customerId and token
     * @param shopId sales channel id
     * @param customerId id of recognized or known customer
     */
    static retrieveProperties(shopId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return yield BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/customers/${customerId}`, configuration);
        });
    }
    /**
     * Sets customer's properties by customerId and token. If customer
     * doesn't exist or is not recognised (no token/customerId == 0) method
     * `.createOrUpdateCustomer(<customersEmailAddress>)` has to be called
     * @param shopId sales channel id
     * @param customerId id of recognized or known customer
     * @param params
     */
    static updateProperties(shopId, customerId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = params;
            return yield BaseRequestHandler_1.BaseRequestHandler.performRequest("PUT", `/shop/${shopId}/customers/${customerId}`, configuration);
        });
    }
    static getAvailablePoints(shopId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/customers/${customerId}/points`, configuration);
        });
    }
    static getLastAddresses(shopId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/customers/${customerId}/address`, configuration);
        });
    }
    /**
     * Sets customers address by api POST call
     * @param shopId sales channel id
     * @param customerId id of recognized or known customer
     * @param address address properties
     */
    static postAddress(shopId, customerId, address) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = address;
            yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("POST", `/shop/${shopId}/customers/${customerId}/address`, undefined, configuration);
        });
    }
    static getRatings(shopId, customerId, limit, offset, isRated) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.params = {
                limit: limit === null || limit === void 0 ? void 0 : limit.toString(),
                offset: offset === null || offset === void 0 ? void 0 : offset.toString(),
                isRated: isRated === null || isRated === void 0 ? void 0 : isRated.valueOf(),
            };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/customers/${customerId}/ratings`, configuration);
        });
    }
    static getReceipts(shopId, customerId, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.params = {
                type: type === null || type === void 0 ? void 0 : type.toString(),
            };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/customers/${customerId}/receipts`, configuration);
        });
    }
    static getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = {
                baseURL,
            };
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", "/api/customer/jwt/token", configuration);
        });
    }
    static loginCustomer(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const authString = btoa(`${credentials.username}:${credentials.password}`);
            const configuration = {
                baseURL,
                headers: { Authorization: `Basic ${authString}` },
            };
            try {
                return yield BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", "/api/customer/login", configuration);
            }
            catch (e) {
                return null;
            }
        });
    }
    static logoutCustomer() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // TODO: Try to find a more elegant way!
                yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("GET", `${window.location.pathname}?Action=Logout`, baseURL);
            }
            catch (e) {
                throw new Error("An error occured while trying to log out\n" + e);
            }
        });
    }
    /**
     * request magic link
     * @param email recipients email address
     * @param redirectUrl url placed in the email to redirect the user to
     */
    static requestMagicLink(email, redirectUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.set("email", email);
            data.set("redirectUri", redirectUrl);
            const config = { data };
            yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("POST", "/api/magic/auth", baseURL, config);
        });
    }
    static requestPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.set("Email", email);
            const config = { data };
            yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("POST", "/api/customer/requestPassword", baseURL, config);
        });
    }
    static newsletterOptin(shopId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("POST", `/shop/${shopId}/customers/${customerId}/newsletter-optin`, undefined, configuration);
        });
    }
    static newsletterOptout(shopId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            yield BaseRequestHandler_1.BaseRequestHandler.performRequestNoResult("POST", `/shop/${shopId}/customers/${customerId}/newsletter-optout`, undefined, configuration);
        });
    }
    static getNewsletterOptions(shopId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("GET", `/shop/${shopId}/customers/${customerId}/newsletter-options`, configuration);
        });
    }
    static setNewsletterOptions(shopId, customerId, newsletterData) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = yield getRequestConfigWithToken_1.getRequestConfigurationWithToken();
            configuration.data = newsletterData;
            return BaseRequestHandler_1.BaseRequestHandler.performRequest("PUT", `/shop/${shopId}/customers/${customerId}/newsletter-options`, configuration);
        });
    }
}
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "createOrUpdateCustomer", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "retrieveProperties", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "updateProperties", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "getAvailablePoints", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "getLastAddresses", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "postAddress", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "getRatings", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "getReceipts", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "getToken", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "loginCustomer", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "logoutCustomer", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "requestMagicLink", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "requestPassword", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "newsletterOptin", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "newsletterOptout", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "getNewsletterOptions", null);
__decorate([
    timer_1.default("API", "Customer")
], CustomerRequestHandler, "setNewsletterOptions", null);
exports.CustomerRequestHandler = CustomerRequestHandler;
var ReceiptType;
(function (ReceiptType) {
    ReceiptType["order"] = "order";
    ReceiptType["invoice"] = "invoice";
    ReceiptType["creditNote"] = "creditNote";
})(ReceiptType = exports.ReceiptType || (exports.ReceiptType = {}));
